import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import CustomButton from "../../components/CustomButton/CustomButton";
import InputField from "../../components/InputField/InputField";
import ModalWrapper from "../../components/Modal/ModalWrapper";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { postDetails } from "../../services/http/http.service";
import { showLoader, hideLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import APIList from "../../utils/constants/APIList";
import { ModalRef } from "../../utils/constants/Interfaces.constants";
import setInputValues from "../../utils/helpers/setInputValue";
import {
  Download,
  EyeFill,
  HandThumbsUp,
  PlusCircleFill,
  Trash3Fill,
  TrashFill,
  Upload,
} from "react-bootstrap-icons";
import "./leaderboard.css";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import Select from "react-select";
import DownloadExcel from "../Download_Excel/download_Excel";
import { number } from "yup";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import { customSingleSelectStyles } from "../../utils/constants/CustomStyles.constants";
import formatActivity from "../../utils/helpers/formatActivity";
import * as XLSX from "xlsx";
import useDebounce from "../../hooks/useDebounce";
import sortByRecentDate from "../../utils/helpers/sortByRecentDate";

interface Leaderboard {
  // id: number;
  count: string;
  attendee_id: number;
  email: any;
  name: string;
  point: any;
  rank: any;
}

interface LeaderBoardData {
  attendee_id: number;
  email: string;
  id: number;
  name: string;
  point: string;
  rank: string;
  status?: any;
}

const Leaderboard: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();

  const [leaderboardData, setLeaderboardData] = useState<LeaderBoardData[]>([]);
  const cmpMounted = useRef(false);
  const [postData, setPostData] = useState([]);
  const modalRef = useRef<ModalRef>(null);
  const modalRefLike = useRef<ModalRef>(null);
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState<any>({
    id: 0,
    name: "Select Folder",
  });
  const downloadExcelRef = useRef<any>(null);
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedYear, setSelectedYear] = useState<number>(
    new Date().getFullYear()
  );
  const [currentOption, setCurrentOption] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [points, setPoints] = useState("");

  // const [SelectedActivity, setSelectedActivity] = useState<any>(null);
  // const [allActivities, setAllActivities] = useState<any>([]);
  const [selectedOperation, setSelectedOperation] = useState<any>(null)
  const [attendeeId, setAttendeeId] = useState<number|null>(null);
  const [optionError, setOptionError] = useState("");

  // useEffect(() => {
  //   // if (cmpMounted.current === true) return;
  //   // cmpMounted.current = true;
  //   fetchData(selectedYear);
  // }, [selectedYear]);

  // const activityOptions = allActivities.map((activity:any)=> ({
  //   value: activity.id,
  //   label: activity.display_activity
  // })) 
  
  // [
  //   { value: 'photoChallengeLike', label: 'Photo Challenge Like' },
  //   { value: 'videoChallengeLike', label: 'Video Challenge Like' },
  //   { value: 'Comment', label: 'Comment' },
  //   { value: 'PostLike', label: 'Post Like' },
  //   { value: 'videoChallenge', label: 'Video Challenge' },
  //   { value: 'Post', label: 'Post' },
  //   { value: 'photoChallenge', label: 'Photo Challenge' },
  //   { value: 'Zigsaw', label: 'Zigsaw' },
  //   { value: 'Quiz', label: 'Quiz' },
  //   { value: 'Training', label: 'Training' },
  //   { value: 'other', label: 'Other' },
  // ];

  const debouncedSearchQuery = useDebounce(searchQuery, 500);

  useEffect(() => {
    const fetchDataAndUpdate = async () => {
      // const data = await fetchData(searchQuery, 5, 1);
      await fetchData(selectedYear, 1, debouncedSearchQuery);
      // setTableData(data?.result || []);
    };
    fetchDataAndUpdate();
  }, [selectedYear, debouncedSearchQuery]);

  // useEffect(() => {
  //     if (!cmpMounted.current) {
  //       cmpMounted.current = true;
  //       fetchData(selectedYear);
  //     }
  //   }, []);

  //   useEffect(() => {
  //     if (cmpMounted.current) {
  //       fetchData(selectedYear);
  //     }
  //   }, [selectedYear]);

  const handlePageChange = (page: number) => {
    // console.log("PAGE",page)
    fetchData(selectedYear, page + 1,debouncedSearchQuery);
  };

  // const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   console.log(e.target.value);
  //   setSearchQuery(e.target.value);
  // };

  const handleSearch = (searchTerm: string) => {
    setSearchQuery(searchTerm); 
  };  

  const fetchData = async (year: number, page: number, query: string = "") => {
    try {
      dispatch(showLoader("Loading data..."));
      const payload = {
        pageSize: 10,
        pageNumber: page,
        year: year,
        searchText: query.trim(),
      };
      setCurrentOption(payload)
      const response = await postDetails(APIList.LEADERBOARD_GETALL, payload);
      console.log("fetched data",payload, response);
      // console.log(
      //   "total records",
      //   Number(response.data?.total?.distinct_attendees || "0")
      //   response.data.total
      // );

      // setTotalRecords(Number(response.data?.total?.distinct_attendees || "0"));
      const sortedFeed = sortByRecentDate(response.data.result, "display_time");

      setTotalRecords(response.data.total);

      const modifiedData = sortedFeed.map((item: any) => ({
        ...item,
        id: item.id,
      }));
        console.log(modifiedData,'modifiedData')
      setLeaderboardData(modifiedData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(showToast("Some error occurred while fetching data"));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const options = [
    { value: "increase", label: "Increase" },
    { value: "decrease", label: "Decrease" },
  ];

  const handleDropdownChange = (selectedOption: Leaderboard | null) => {
    setSelectedValue(selectedOption);
  };

//   const handleDownloadCSV = async () => {
//     // if (downloadExcelRef.current) {
//     //   downloadExcelRef.current.exportToExcel("Leaderboard");
//     // }

//     try {
//       dispatch(showLoader("Downloading data..."));
//       const payload = {
//         pageSize: 10,
//         pageNumber: 0,
//         year: selectedYear,
//       };
//       const response = await postDetails(APIList.LEADERBOARD_GETALL, payload);
// console.log(response,'response');

//       const modifiedData = response.data.result.map((item: any) => ({
//         ...item,
//         lastactivitytime: new Date(item.lastactivitytime).toLocaleString(
//           "en-GB",
//           {
//             day: "2-digit",
//             month: "2-digit",
//             year: "numeric",
//             hour: "2-digit",
//             minute: "2-digit",
//             hour12: true,
//           }
//         ),
//       }));
// console.log(modifiedData,'modifiedData');

//       const ws = XLSX.utils.json_to_sheet(modifiedData);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, "Leaderboard");

//       XLSX.writeFile(wb, `Leaderboard_${selectedYear}.xlsx`);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       dispatch(showToast("Some error occurred while fetching data"));
//       setTimeout(() => dispatch(hideToast()), 3000);
//     } finally {
//       dispatch(hideLoader());
//     }
//   };
  
const handleDownloadCSV = async () => {
  try {
    dispatch(showLoader("Downloading data..."));
    const payload = {
      pageSize: 10,
      pageNumber: 0,
      year: selectedYear,
    };
    
    const response = await postDetails(APIList.LEADERBOARD_GETALL, payload);
    console.log(response, 'response');

    // Modify the data and remove the 'id' field
    const modifiedData = response.data.result.map((item: any) => {
      const { id, ...rest } = item;  // Destructure to remove 'id'
      
      return {
        ...rest,
        lastactivitytime: new Date(item.lastactivitytime).toLocaleString(
          "en-GB",
          {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }
        ),
      };
    });

    console.log(modifiedData, 'modifiedData');

    // Create Excel file from modified data without 'id'
    const ws = XLSX.utils.json_to_sheet(modifiedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Leaderboard");

    // Download the Excel file
    XLSX.writeFile(wb, `Leaderboard_${selectedYear}.xlsx`);
    
  } catch (error) {
    console.error("Error fetching data:", error);
    dispatch(showToast("Some error occurred while fetching data"));
    setTimeout(() => dispatch(hideToast()), 3000);
  } finally {
    dispatch(hideLoader());
  }
};

  const handleEdit = async (item: any) => {
    console.log("ITEM",item);
    setAttendeeId(item.id)
    setShowEditModal(true);
    //  setPointData({
    //     point:
    //  })
  };

  const deleteItemById = async (item: any) => {
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.delete_leatherboard, {
        id: item.id,
      });

      if (response.statusCode === 200) {
        dispatch(showToast("Data deleted successfully"));
        setTimeout(() => dispatch(hideToast()), 3000);
        fetchData(selectedYear, 1);
      } else if (response.status === "Failed" || response.Status === "Failed") {
        dispatch(showToast(`Cannot delete data.`));
        setTimeout(() => dispatch(hideToast()), 3000);
      } else {
        dispatch(showToast(`Some error occurred while deleting data.`));
        setTimeout(() => dispatch(hideToast()), 3000);
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      dispatch(
        showToast(
          `An error occurred while trying to delete the data. Please try again.`
        )
      );
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handleCloseEditModal = () =>{ 
    setPoints("");
    setSelectedOperation(null)
    setShowEditModal(false);
  }

  const handleChangePointPopup = () => {
    navigate("/leaderboard/changePoint");
  };

  const handleChange = (selectedOption: any) => {
    console.log("Selected option:", selectedOption);
    // You can update your state or perform other actions here
    setSelectedOperation(selectedOption);
  };

  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.toggleModalWrapper(false);
    }
  };

  const handleViewLike = async (item: any) => {
    console.log(item,'itemmm');
    if (modalRefLike.current) {
      try {
        const payload = {
          id: item.id,
          year: selectedYear,
        };
        dispatch(showLoader("Loading data..."));
        const response = await postDetails(APIList.LEADERBOARD_GETALL, payload);
        // console.log("Leaderboard get data",response.data.result)
        const transformedData = response.data.result.map((item: any) => ({
          ...item,
          display_activity: formatActivity(item.activity),
        }));
        setPostData(transformedData || []);
        modalRefLike.current.toggleModalWrapper(true);
      } catch (error) {
        console.error("Error fetching data:", error);
        dispatch(showToast("Some error occurred while fetching data"));
        setTimeout(() => dispatch(hideToast()), 3000);
      } finally {
        dispatch(hideLoader());
      }
    }
  };

  const handleBulkDelete = async () => {
    try {
      const ids = Array.from(selectedItems);
      console.log(ids);
      const response = await postDetails(APIList.DELETE_PEOPLE, { id: ids });
      console.log(response);

      if (response.statusCode === 200) {
        dispatch(showToast("Users deleted successfully."));
        setTimeout(() => dispatch(hideToast()), 3000);
        setShowDeleteModal(false);
        setSelectedItems(new Set());
        fetchData(selectedYear, 1);
      } else if (response.status === "Failed" || response.Status === "Failed") {
        dispatch(showToast(`Cannot bulk delete users.`));
        setTimeout(() => dispatch(hideToast()), 3000);
      } else {
        dispatch(showToast(`Some error occurred while deleting users.`));
        setTimeout(() => dispatch(hideToast()), 3000);
      }
    } catch (error) {
      console.error("Error deleting users:", error);
      dispatch(showToast(`Some error occurred while deleting users.`));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  const addExtraPoint = async (e: React.FormEvent<HTMLFormElement> )=>{
        e.preventDefault();

        let extraPoints:number = 0;

        if(!selectedOperation){
          setOptionError("Please select an option");
          return;
        }

        setOptionError("");

        if(selectedOperation.value === "increase"){
          extraPoints = Number(points)
        } else if(selectedOperation.value === "decrease"){
          extraPoints = 0 - Number(points)
        }

        const payload = {
          point: extraPoints,
          activity: "Other",
          year: String(selectedYear),
          activity_id: 0,
          attendee_id: attendeeId,
        }

        try {
          dispatch(showLoader("Updating data..."));
          const response = await postDetails(APIList.EXTRA_POINT, payload);
          console.log("Response",response)
          if (response.statusCode === 200) {
            let message: string = "";
            if(selectedOperation.value === "increase"){
              message = "Extra Points Added Successfully.";
            } else if(selectedOperation.value === "decrease"){
              message = "Points Removed Successfully.";
            }
            dispatch(showToast(`${message}`));
            setTimeout(() => dispatch(hideToast()), 3000);
            const page = currentOption.pageNumber
            const query = currentOption.searchText   // Added this for editing extra point

            fetchData(selectedYear,page,query);
        } else{
            dispatch(showToast(`Failed to add extra points.`));
            setTimeout(() => dispatch(hideToast()), 3000);
            return;
          }
        } catch (error) {
          console.error("Error updating data:", error);
          dispatch(showToast(`Some error occurred while adding points`));
          setTimeout(() => dispatch(hideToast()), 3000);
        } finally {
          dispatch(hideLoader());
          handleCloseEditModal()
        }
        
  }

  const handlePost = () => {
    console.log("handle post is clicked");
  };
  // const handlePostStatus = () => { console.log("handle post status is clicked")};

  const columns: TableColumn[] = [
    { key: "name", label: "Name",
      //  sortable: true, 
       dataType: "string" },
    {
      key: "email",
      label: "Email",
      //  sortable: true,
      dataType: "string",
    },
    { key: "rank", label: "Rank", 
      // sortable: true,
       dataType: "string" },
    // { key: "point", label: "Point", sortable: true },
    {
      key: "point",
      label: "Total Point",
      dataType: "button",
      // button: {
      //   label: (item) => (
      //     <div
      //       key={item.activity}
      //       style={{ display: "flex", alignItems: "center" }}
      //     >
      //       <EyeFill style={{ marginRight: "8px" }} />
      //       {item.point || 0}
      //     </div>
      //   ),
      //   onClick: (item) => handleViewLike(item),
      // },
      render: (item) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "2",
            width: "100px",
            margin: "auto",
            padding: "6px",
            color: "#fff",
            backgroundColor: "rgb(255, 204, 0)",
            cursor: "pointer",
          }}
          onClick={() => handleViewLike(item)}
          // className="btn-secondary"
        >
          <EyeFill style={{ marginRight: "8px" }} />
          {item.point || 0}
        </div>
      ),
      // sortable: true,
    },
  ];

  // const currentYear = new Date().getFullYear();
  // const yearOptions = [];
  // for (let year = currentYear; year <= 2024; year++) {
  //   yearOptions.push({
  //     label: `${year}`,
  //     onClick: () => setSelectedYear(year),
  //   });
  // }

  const startYear = 2024;
  const endYear = new Date().getFullYear();
  // const endYear = 2030;
  const yearOptions = [];
  for (let year = endYear; year >= startYear; year--) {
    yearOptions.push({
      label: `${year}`,
      onClick: () => {
        setSelectedYear(year);
      },
    });
  }

  // console.log(selectedYear);

  const buttons = [
    {
      label: "Please Select",
      theme: "danger",
      onClick: handlePost,
      dropdown: yearOptions,
    },
    {
      label: "Delete",
      theme: "danger",
      icon: <TrashFill />,
      onClick: () => setShowDeleteModal(true),
      disabled: selectedItems.size === 0,
    },
    {
      label: "Add/Edit Point",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: handleChangePointPopup,
    },
    {
      label: "Download-Excel",
      theme: "warning",
      icon: <Download />,
      onClick: handleDownloadCSV,
    },
  ];

  const handleCheckboxChange = (selectedIds: Set<number>) => {
    // console.log(selectedIds);
    setSelectedItems(selectedIds);
  };

  const handleKeyDownNumber = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
        e.preventDefault();
    }
};

// const handleSelectedActivity = (selectedOption:any) => {
//   setSelectedActivity(selectedOption); 
//   console.log('Selected activity:', selectedOption);
// };

  return (
    <LayoutContainer title="leaderboard">
      <DownloadExcel
        ref={downloadExcelRef}
        excelData={leaderboardData}
        fileName="Leaderboard"
        buttonText=""
      />

      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete the selected items?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-warning text-white"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </Button>
          <Button className="btn-danger" onClick={handleBulkDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} onHide={handleCloseEditModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Points</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-scrollable">
          <div>
            <form onSubmit={addExtraPoint}>

            <div className="row" style={{height: "108px"}}>
                <div className="col-12" style={{ fontSize: "11.2px" }}>
                  {/* <InputField
                                name="year"
                                label="Year"
                                type="text"
                                value={year}
                                onChangeInput={(e) => setYear(e.target.value)}
                                minLength={1}
                                maxLength={50}
                                disabled
                            /> */}
                  <label htmlFor="changeOption" className="mb-1 font-12 weight-500">
                    Select Option<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="changeOption"
                    name="changeOption"
                    styles={customSingleSelectStyles}
                    value={selectedOperation}
                    onChange={handleChange}
                    options={options}
                    isSearchable={false}
                    placeholder="Increase/Decrease"
                    className="font-12"
                  />
                </div>
                {optionError && <span className="error-text mt-1"
                style={{fontSize: "11.2px"}}
                >{optionError}</span>}
              </div>

              <div className="row">
                        <div className="col-12" style={{height: "80px"}}>
                            <InputField
                                name="point"
                                label="Point"
                                type="text"
                                value={points}
                                onChangeInput={(e) => setPoints(e.target.value)}
                                onKeyDown={handleKeyDownNumber}
                                minLength={1}
                                maxLength={50}
                                required={true}
                            />
                        </div>
              </div>

              
              <CustomButton type="submit" size="md" theme="yellow">
                Submit
              </CustomButton>
            </form>
          </div>
        </Modal.Body>
      </Modal>

      <ModalWrapper ref={modalRefLike} title="Summary">
        <div
          style={{
            maxHeight: "400px",
            overflowY: "auto",
          }}
        >
          {postData ? (
            postData.map((item: any) => (
              <div
                key={item.activity}
                className="d-flex  justify-content-between align-items-center border rounded  my-2"
                style={{ backgroundColor: "white" }}
              >
                <Button
                  variant="dark"
                  className="px-4 hello m-0 py-3"
                  style={{ fontSize: "12px" }}
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.currentTarget.blur();
                  }}
                >
                  {item.display_activity}
                </Button>
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    marginRight: "15px",
                  }}
                >
                  {item.total_points}
                </span>
              </div>
            ))
          ) : (
            <div>No Data</div>
          )}
        </div>
      </ModalWrapper>

      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Leaderboard
        </h2>
        <PageHeader buttons={buttons} />
      </div>
      {/* <div className="d-flex justify-content-end mx-4 mt-2">
        <InputGroup style={{ width: "340px" }} className="mb-3">
          <Form.Control
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </InputGroup>
      </div> */}
      <div>
        <CommonTable<LeaderBoardData>
          data={leaderboardData}
          columns={columns}
          onEdit={handleEdit}
          onDelete={deleteItemById}
          pagination={true}
          rowsPerPage={10}
          actions={{
            view: false,
            edit: true,
            delete: true,
            checkbox: true,
            status: false,
            showModal: false,
          }}
          onPageChange={handlePageChange}
          apiPagination={true}
          onCheckboxChange={handleCheckboxChange}
          totalPageCount={totalRecords}
          apiSearch={true}
          onSearch={handleSearch}
        />
      </div>
    </LayoutContainer>
  );
};

export default Leaderboard;
